<template>
    <section class="section about-app-area ptb_100">
        <div class="shapes-container">
            <div class="shape-1"></div>
        </div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-lg-6">
                    <!-- About Text -->
                    <div class="about-text">
                        <!-- Headings -->
                        <div class="headings d-flex align-items-center mb-4">
                            <span class="text-uppercase d-none d-sm-block">About</span>
                            <h2 class="text-capitalize">Never kick a rule again</h2>
                        </div>
                        <p class="my-3">By Rule is a study companion for anyone interested in studying and learning the fundamentals of college basketball officiating. It is the most complete basketball rules app designed for iPhone.</p>
                        <p class="d-none d-sm-block my-3">Discover the intent behind the rules that govern the game of basketball. Using this amazing tool, casual fans, players, coaches, and officials can gain an edge in understanding the nuances of the game.</p>
                        <!-- Store Buttons -->
                        <div class="button-group store-buttons">
                            <a href="https://apps.apple.com/us/app/by-rule/id1532845521" class="btn btn-bordered">
                                <i class="icofont icofont-brand-apple dsp-tc"></i>
                                <p class="dsp-tc">AVAILABLE ON
                                    <br> <span>Apple Store</span></p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <!-- About Thumb -->
                    <div class="about-thumb text-center d-none d-lg-block">
                        <img src="assets/img/3D copy.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>